import { useState } from 'react';
import DonateButton from './DonateButton';
import Link from './Link';
import LabLogo from './scene/LabLogo';
import { HEADER_CLASSES } from '../constants/classNames';
import { ROUTES, SITE_NAME } from '../constants/config';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/SiteHeader.css';

const NAV_LINKS = [
  { route: ROUTES.LAB, label: 'Lab', pages: ['lab'] },
  { route: ROUTES.ELEMENTS, label: 'Elements', pages: ['elements', 'element'] },
  { route: ROUTES.REACTIONS, label: 'Reactions', pages: ['reactions', 'reaction'] },
  { route: ROUTES.PARENTS, label: 'Parents & Teachers', pages: ['parents', 'worksheet', 'worksheet-answers'] },
  { route: ROUTES.ABOUT, label: 'About Us', pages: ['about'] },
];

export default function SiteHeader({ currentPage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((isOpen) => !isOpen);

  return (
    <header className={HEADER_CLASSES.root}>
      <Link className={HEADER_CLASSES.brand} to={ROUTES.LAB} onClick={closeMenu}>
        <LabLogo className={HEADER_CLASSES.logo} size={40} />
        <span className={HEADER_CLASSES.title}>{SITE_NAME}</span>
      </Link>

      <button
        type="button"
        className={HEADER_CLASSES.menuToggle}
        aria-expanded={isMenuOpen}
        aria-controls="site-nav"
        aria-label="Toggle menu"
        onClick={toggleMenu}
      >
        {isMenuOpen ? '✕' : '☰'}
      </button>

      <nav id="site-nav" className={joinClassNames(HEADER_CLASSES.nav, isMenuOpen && HEADER_CLASSES.navOpen)}>
        {NAV_LINKS.map(({ route, label, pages }) => {
          const isCurrent = pages.includes(currentPage);
          return (
            <Link
              key={route}
              to={route}
              onClick={closeMenu}
              aria-current={isCurrent ? 'page' : undefined}
              className={joinClassNames(HEADER_CLASSES.navLink, isCurrent && HEADER_CLASSES.navLinkActive)}
            >
              {label}
            </Link>
          );
        })}
        <DonateButton />
      </nav>
    </header>
  );
}
